import { useQuery } from '@tanstack/react-query';
import { CacheData } from '../../@types/cacheData';

export const useGameRoundWebsocketQuery = () =>
  useQuery<CacheData['gameRoundData']>({
    queryKey: ['gameRoundData'],
    queryFn: () => undefined as unknown as CacheData['gameRoundData'],
    enabled: false,
    staleTime: Infinity,
  });
